/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendContactResponse
 */
export interface SendContactResponse {
    /**
     * 
     * @type {string}
     * @memberof SendContactResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof SendContactResponse
     */
    externalUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendContactResponse
     */
    isDuplicate?: boolean;
}

/**
 * Check if a given object implements the SendContactResponse interface.
 */
export function instanceOfSendContactResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function SendContactResponseFromJSON(json: any): SendContactResponse {
    return SendContactResponseFromJSONTyped(json, false);
}

export function SendContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendContactResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'isDuplicate': !exists(json, 'isDuplicate') ? undefined : json['isDuplicate'],
    };
}

export function SendContactResponseToJSON(value?: SendContactResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'externalUrl': value.externalUrl,
        'isDuplicate': value.isDuplicate,
    };
}

